import dayjs from "dayjs";
import { useCallback } from "react";
const safeParseURL = (value: string): URL | null => {
  try {
    return new URL(value);
  } catch {
    return null;
  }
};

const useValidation = () => {
  const MAX_LENGTH = 100;
  const containsMaliciousCharacters = (val: string) =>
    ["<", ">", '"', "'", "`", "=", "{", "}", "(", ")"].some((char) =>
      val.includes(char)
    ) || val.toLowerCase().includes("script");
  const isObjectValid = useCallback((data: any): boolean => {
    return Object.entries(data).every(([key, value]) => {
      const trimmedValue = typeof value === "string" ? value.trim() : "";
  
      if (
        trimmedValue &&
        (trimmedValue.length > MAX_LENGTH ||
          containsMaliciousCharacters(trimmedValue))
      ) {
       return false; 
      }
      const skipKeys = [
        "OfficeNumber",
        "State",
        "City",
        "leadInvestorName",
        "syndicateInvestorName",
        "OfficeNumber2",
        "SignatureData",
        "SignatureExtenstion",
        "Signature",
        "WebSite",
        "BankPhoneNumber",
        "PassportNumber",
        "DriversLicenseNumber",
        "SwiftCode",
        "IBANNumber",
        "WebSite",
        "BSB",
       
        "TaxResidencyCountry"



      ];
      if (skipKeys.includes(key)) {
        return true;
      }
  
      if (key === "AccountNumber") {
        const strValue = String(value);
        return strValue.length >= 10 && strValue.length <= 12 && !isNaN(Number(strValue));
      }
     if(key === "FirstName" || key === "LastName"){ 
       return  value !=="" && trimmedValue.length > 0 && trimmedValue.length <= 50 && !containsMaliciousCharacters(trimmedValue) && isNaN(Number(trimmedValue));

     }
      if (key === "TaxID" || key === "TFN" || key === "TaxFileNumber" || key === "SSN") {
      
       return value !=="" &&  trimmedValue.length >= 8 && trimmedValue.length <= 15  && !containsMaliciousCharacters(trimmedValue);
        }
      if(key === "PassportNumber" || key === "DriversLicenseNumber") {
        return value !=="" && trimmedValue.length >= 6  && !containsMaliciousCharacters(trimmedValue);
      }
       if(key === "DateOfBirth") {
        if (!value) {
           return false
        } else {
          const strValue = String(value);
          const selectedDate = dayjs(strValue);
          const eighteenYearsAgo = dayjs().subtract(18, 'year');
      
          if (selectedDate.isAfter(eighteenYearsAgo)) {
            return false; // ❌ User is under 18 years old
          }
          else {
            return true
          }
        }
       }
 if (key === "GovernmentRegistrationUrl") {

  try {
    const url = trimmedValue.startsWith("http://") || trimmedValue.startsWith("https://")
      ? new URL(trimmedValue)
      : new URL("https://" + trimmedValue);

    const hostname = url.hostname;
    const parts = hostname.split(".");
    const tld = parts.at(-1);

    return (
      ["http:", "https:"].includes(url.protocol) &&
      parts.length > 1 &&
      !!tld &&
      tld.length >= 2 &&
      /^[a-zA-Z]+$/.test(tld) &&
      parts.every((p) => /^[a-zA-Z0-9-]+$/.test(p) && p.length > 0) &&
      !parts.every((p) => /^\d+$/.test(p)) &&
      !trimmedValue.includes(" ") &&
      !trimmedValue.includes("..") &&
      trimmedValue.length <= 300 &&
      !containsMaliciousCharacters(trimmedValue)
    );
  } catch {
    return false;
  }
}

      
if (key === "CompanyWebSite") {
  if (!trimmedValue) return true;

  let value = trimmedValue.trim();

  if (value.includes(" ")) return false;

  if (
    !value.startsWith("http://") &&
    !value.startsWith("https://")
  ) {
    value = "https://" + value;
  }

  const url = safeParseURL(value);
  if (!url) return false;

  if (url.protocol !== "http:" && url.protocol !== "https:") return false;
  if (!url.hostname || !url.hostname.includes(".")) return false;
  if (value.length > 2048) return false;

  return true;
}

      
    
  
      // ✅ Validate Swift Code (8-11 uppercase characters)
      // if (key === "SwiftCode") {
      //   const strValue = String(value);
      //   return strValue.length >= 8 && strValue.length <= 11 && strValue === strValue.toUpperCase();
      // }
  
      // // ✅ Validate IBAN Number (15-34 uppercase characters)
      // if (key === "IBANNumber") {
      //   const strValue = String(value);
      //   return strValue.length >= 15 && strValue.length <= 34 && strValue === strValue.toUpperCase();
      // }
  
      // ✅ Validate postal code (4-6 digits)
      if (key === "PostalCode") {
        const strValue = String(value);
        return strValue.length >= 4 && strValue.length <= 6 && !isNaN(Number(strValue));
      }
  
      // ✅ Validate phone number (10-15 digits, allows "+")
      if (key === "PhoneNumber") {
        const strValue = String(value);
        return strValue.length >= 10 && strValue.length <= 15 && !isNaN(Number(strValue.replace("+", "")));
      }
      // if (key === "OfficeNumber") {
      //   const strValue = String(value);
      //   return strValue.length >= 10 && strValue.length <= 15 && !isNaN(Number(strValue.replace("+", "")));
      // }
  
      // ✅ Validate email format
      if(key === "Country" || key === "CountryOfRegistration"){
        return  value !==""
      }
      if (key === "Email" || key === "OfficeEmail") {
        const strValue = String(value);
        const atIndex = strValue.indexOf("@");
        const lastDotIndex = strValue.lastIndexOf(".");
      
        const isValidEmail =
          atIndex > 0 &&
          lastDotIndex > atIndex + 1 &&
          lastDotIndex < strValue.length - 1 &&
          !strValue.includes(" ") &&
          strValue.split("@").length === 2;
      
        return isValidEmail;
      }
      
  
      // ✅ Validate SubscriptionAmount (should be a number and not empty)
      if (key === "SubscriptionAmount") {
        return value !== "" && !isNaN(Number(value));
      }
  
      // ✅ Validate PercentageofInvestment (should be a number between 0 and 100)
      if (key === "PercentageofInvestment") {
        const numValue = Number(value);
        return numValue >= 0 && numValue <= 100 && !isNaN(numValue);
      }
  
      // ✅ General validations for strings
      if (typeof value === "string") {
        return value.trim() !== ""; // Check non-empty strings
      } else if (value instanceof File) {
        return true; // Allow valid file uploads
      } else if (Array.isArray(value)) {
        return value.every(isObjectValid); // Recursively validate arrays
      } else if (typeof value === "object" && value !== null) {
        return isObjectValid(value); // Recursively validate objects
      }
  
      return false; // ❌ If none of the conditions match, it's invalid
    });
  }, []);
  
  return { isObjectValid };
};

export default useValidation;
